// js/common/tab.js（トップ/アーカイブ共通・PHP変更不要）
(() => {
  const TABLIST_SELECTOR = '.p-works__tabs, .p-top-works__tabs, [role="tablist"]';
  const TAB_SELECTOR     = '.p-works__tab[role="tab"], .p-top-works__tab[role="tab"], [role="tab"][data-tab]';
  const PANELS_WRAP_SEL  = '.c-tabs__panels, .p-works__panels, .p-top-works__panels';
  const PANEL_SELECTOR   = '.p-works__panel[role="tabpanel"], .p-top-works__panel[role="tabpanel"], [role="tabpanel"]';

  const slugFromHash = () => {
    const m = location.hash.match(/(?:^|#|&|;)works=([A-Za-z0-9_-]+)/);
    return m ? m[1] : null;
  };

  const hideAfterFade = (panel) => {
    const onEnd = (e) => {
      if (e && e.target !== panel) return;
      panel.removeEventListener('transitionend', onEnd);
      if (!panel.classList.contains('is-active')) panel.hidden = true;
    };
    panel.addEventListener('transitionend', onEnd);
    setTimeout(() => {
      panel.removeEventListener('transitionend', onEnd);
      if (!panel.classList.contains('is-active')) panel.hidden = true;
    }, 300);
  };

  const getPanelIdForTab = (tab) =>
    tab.getAttribute('aria-controls') || (tab.dataset.tab ? `panel-${tab.dataset.tab}` : '');

  // ページ内に複数セットがあってもOK（1つでもOK）
  document.querySelectorAll(TABLIST_SELECTOR).forEach((tablist) => {
    // 二重バインド防止
    if (tablist.__tabsBound) return;
    tablist.__tabsBound = true;

    // ルート推定（なければdocumentでも動く）
    const root   = tablist.closest('.p-works__content, .p-top-works__content') || document;
    const tabs   = [...tablist.querySelectorAll(TAB_SELECTOR)];
    const wrap   = root.querySelector(PANELS_WRAP_SEL) || root;
    const panels = [...wrap.querySelectorAll(PANEL_SELECTOR)];

    if (tabs.length === 0 || panels.length === 0) return;

    const setTabA11y = (activeTab) => {
      tabs.forEach((t) => {
        const on = t === activeTab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
    };

    const setPanels = (activeId) => {
      panels.forEach((p) => {
        const on = p.id === activeId;
        p.classList.toggle('is-active', on);
        if (on) {
          p.hidden = false;
        } else {
          hideAfterFade(p);
        }
      });
    };

    const activateByTab = (tab, { syncHash = true } = {}) => {
      if (!tab) return;
      const nextPanelId = getPanelIdForTab(tab);
      if (!nextPanelId) return;

      const currentPanel = panels.find((p) => p.classList.contains('is-active'));
      if (currentPanel && currentPanel.id === nextPanelId) return;

      const nextPanel = panels.find((p) => p.id === nextPanelId);
      if (!nextPanel) return;

      nextPanel.hidden = false;
      setTabA11y(tab);
      setPanels(nextPanelId);

      if (syncHash) {
        const slug = tab.dataset.tab;
        if (slug) {
          const base = location.href.split('#')[0];
          history.replaceState(null, '', `${base}#works=${slug}`);
        }
      }
    };

    // キーボード操作
    tablist.addEventListener('keydown', (e) => {
      const current = document.activeElement;
      const idx = tabs.indexOf(current);
      if (idx === -1) return;

      let nextIdx = null;
      if (e.key === 'ArrowRight') nextIdx = (idx + 1) % tabs.length;
      if (e.key === 'ArrowLeft')  nextIdx = (idx - 1 + tabs.length) % tabs.length;
      if (e.key === 'Home')       nextIdx = 0;
      if (e.key === 'End')        nextIdx = tabs.length - 1;

      if (nextIdx !== null) {
        e.preventDefault();
        tabs[nextIdx].focus();
        activateByTab(tabs[nextIdx]);
      }
    });

    // クリック操作
    tablist.addEventListener('click', (e) => {
      const btn = e.target.closest('.p-works__tab, .p-top-works__tab, [role="tab"][data-tab]');
      if (!btn) return;
      e.preventDefault();
      activateByTab(btn);
    });

    // 初期tabindex
    tabs.forEach((t) => t.setAttribute('tabindex', '-1'));

    // 初期表示：#works=slug → .is-active → 先頭
    const slug = slugFromHash();
    let initialTab =
      (slug && tabs.find((t) => t.dataset.tab === slug)) ||
      tabs.find((t) => t.classList.contains('is-active')) ||
      tabs[0];

    if (initialTab) {
      activateByTab(initialTab, { syncHash: false });
    }

    // 戻る/進む対応
    window.addEventListener('hashchange', () => {
      const s = slugFromHash();
      if (!s) return;
      const t = tabs.find((t) => t.dataset.tab === s);
      if (t) activateByTab(t, { syncHash: false });
    });
  });
})();
